import { inject, observer } from "mobx-react";
import { type FunctionComponent, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import AnchorButton from "nvent-web/components/Button/AnchorButton";
import AppStore from "nvent-web/stores/App";
import { catalogLinks } from "nvent-web/utils/catalogLinks";

import style from "./CatalogBar.module.scss";

interface CatalogBarPropsInner {
  app: AppStore;
}

export const CatalogBannerWrapper = ({
  children,
}: {
  children?: ReactNode;
}) => <section className={style.catalogBanner}>{children}</section>;

const CatalogBarInner: FunctionComponent<CatalogBarPropsInner> = ({
  app,
}: CatalogBarPropsInner) => (
  <CatalogBannerWrapper>
    <div className={style.catalogBannerContent}>
      <span className={style.catalogBannerTitle}>
        <FormattedMessage id="certifiedPage.catalog.title" />
      </span>
      <div className={style.arrow} />
      <AnchorButton
        className={style.catalogBannerButton}
        href={catalogLinks[app.locale]}
      >
        <FormattedMessage id="certifiedPage.catalog.button" />
      </AnchorButton>
    </div>
  </CatalogBannerWrapper>
);

export const CatalogBar = compose<Record<string, unknown>>(
  inject("app"),
  observer
)(CatalogBarInner);
